export default function indexItemMarkup( props ) {
    const { url, imageUrl, title, author, pubDate, label } = props;

    const imageFallback = `${window.location.origin}/wp-content/themes/adweek-next/src/images/adweek-placeholder.png`;

    const imageMarkup = imageUrl ? imageUrl : imageFallback;

    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    const dateObj  = new Date( pubDate );

    let premiumLabel = '';

    return `<section id="" class="section section--index-item ">
      <div class="section--index-item_avatar">
        <!-- BEGIN: atom-base -->
        <a href="${url}"><img loading="lazy" src="${imageMarkup}" alt="" class="image image-partner" data-lazy-src="${imageMarkup}"></a>
        <!-- END: atom-base -->
      </div>
      <div class="section--index-item_info">
        <a href="${url}" class="link-reset"> <p class="section__title"> ${title} </p> </a>
        <p class="section__byline"> By ${author} </p>
        ${premiumLabel}
        <p class="section__byline">  ${dateObj.toLocaleDateString( 'en-US', options )} </p>
        <p class="section__body"></p>
      </div>
    </section>`;
}
